function CapitalizeFirstLetter(word) {
    const [firstLetter, ...rest] = word;
    return firstLetter.toUpperCase() + rest.join('');
}

export default CapitalizeFirstLetter;